<template>
    <section class="mobile-favorite">
        <!--工具条-->
        <FullCalendar :locale="locale"
                      :first-day="1"
                      ref="fullCalendar"
                      defaultView="timeGridDay"
                      :plugins="calendarPlugins"
                      :now-indicator="true"
                      :all-day-slot="false"
                      min-time="00:00:00"
                      max-time="24:00:00"
                      slot-duration="00:30:00"
                      slot-label-interval="01:00:00"
                      :height='content_height'
                      :nav-links="true"
                      event-class-name="course-inner-text"
                      :views="viewsSetting"
                      :events="loadEvents"
                      :event-time-format="eventTimeFormat"
                      :slot-label-format="slotLabelFormat"
                      @eventClick="handleEventClick"
                      :custom-buttons="customButtons"
                      :selectable="true"
                      :select-overlap="false"
                      :select-allow="allow"
                      @select="handleSelect"
                      scroll-time="08:00"

                      :header="{left:'title newMeeting,goList', right:'timeGridDay,timeGridWeek,dayGridMonth,listWeek prev,next'}"
        />

        <meeting-view :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees" btn_modify btn_delete
                      :mobile="true" @delete="handleDelete" @cancel="view_mode = false">
        </meeting-view>
    </section>
</template>

<script>
    import CalendarMixins from "../../common/mixins/calendar-mixin";
    import MeetingView from "@/components/meeting-view";

    export default {
        name: "mobile-calendar",
        mixins:[CalendarMixins],
        components:{MeetingView},
        data() {
            return {
                viewsSetting:{
                    dayGrid: {
                        // options apply to dayGridMonth, dayGridWeek, and dayGridDay views
                        titleFormat:{month:'2-digit'},
                    },
                    timeDayGrid: {
                        // options apply to timeGridWeek and timeGridDay views
                        titleFormat:{month:'2-digit',day:'2-digit'}
                    },
                    week: {
                        // options apply to dayGridWeek and timeGridWeek views
                        titleFormat:{day:'2-digit'},
                    },
                    day: {
                        // options apply to dayGridDay and timeGridDay views
                        titleFormat:{month:'2-digit',day:'2-digit'}
                    }
                },
                poll_view:false,polls:{},
                content_height:100,
                screen_height:100,
            }
        },
        mounted() {
            this.screen_height =  document.body.clientHeight;
            this.content_height = this.screen_height - 125;
        },
        methods:{
            handleResize(arg){
                this.screen_height =  document.body.clientHeight;
                this.content_height = this.screen_height - 125;
                arg.updateSize();
            }
        }
    }
</script>

<style lang="scss">
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';
    @import "~@fullcalendar/list/main.css";

    .fc-icon.fc-icon-el-icon {
        font-family: 'element-icons'!important;
    }

    .mobile-favorite {

        .fc-toolbar.fc-header-toolbar {
            margin-bottom: 0.5em;
            display: block;

            .fc-right {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
            }
            .fc-left {
                display: flex;
                justify-content: space-between;
            }
        }
        .course-inner-text {
            color: white;
            font-size: 14px;
            background-color: #009688;
            transition: all 0.4s ease;

            .fc-time {
                color: white;
                font-size: 13px;
                font-weight: bold;
            }

            &:hover {
                color: whitesmoke;
                cursor: pointer;
                background-color: #0288d1;
                border-color: #0288d1;
                box-shadow: 1px 1px 9px rgba(0, 0, 0, 0.5);
                transition: all 0.4s ease;

            }

            &.fc-list-item {
                background-color: transparent;
                color: black;

                &:hover {
                    box-shadow: none;
                }
            }
        }


    }

</style>
